var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.element,_vm._b({tag:"component",class:_vm.customClass},'component',_vm.elementProps,false),[_vm._t("default",function(){return [_vm._v("Page Heading")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }